import { render, staticRenderFns } from "./give-proudly-ForgotPasswordChangePassword.vue?vue&type=template&id=0f881876&scoped=true"
import script from "./give-proudly-ForgotPasswordChangePassword.vue?vue&type=script&lang=js"
export * from "./give-proudly-ForgotPasswordChangePassword.vue?vue&type=script&lang=js"
import style0 from "./give-proudly-ForgotPasswordChangePassword.vue?vue&type=style&index=0&id=0f881876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f881876",
  null
  
)

export default component.exports